import React from 'react';
import { connect } from 'react-redux';
import '../../../css/graph/graph-context-menu.less';
import { isNullOrEmpty, getByID } from '../../utils/core';
import { getSystemFlowName } from './utils';
import { setContextMenuData as setContextMenuDataAction } from '../../actions/reduxActions/graphEditor';
import translations from '../../translations';

export const GraphContextMenu = ({
    contextMenu,
    mapElements,
    groupElements,
    openConfig,
    editingToken,
    flowId,
    setContextMenuData,
    setSelectedMapElement,
}) => {
    const { show, x, y, activeElement } = contextMenu || {};
    if (!show || isNullOrEmpty(x) || isNullOrEmpty(y)) {
        return null;
    }
    const { id, type } = activeElement;

    const editAction = onClick => (
        <button
            className="graph-menu-item"
            onClick={onClick}
        >
            {translations.GRAPH_action_edit}
        </button>
    );

    const editMetadataAction = (
        <button
            className="graph-menu-item"
            onClick={() => {
                setSelectedMapElement(id, type);
                setContextMenuData(null);
            }}
        >
            {translations.GRAPH_action_edit_metadata}
        </button>
    );

    const copyAction = (
        <div className="graph-menu-item">{translations.GRAPH_action_copy}</div>
    );

    const deleteAction = onClick => (
        <button
            className="graph-menu-item"
            onClick={onClick}
        >
            {translations.GRAPH_action_delete}
        </button>
    );

    const pasteAction = (
        <div className="graph-menu-item">{translations.GRAPH_action_paste}</div>
    );

    let items = [];

    switch (type) {
    case 'map': {
        const element = getByID(id, mapElements);
        const { elementType } = element;
        items = [
            editAction(() => {
                openConfig(
                    getSystemFlowName(elementType),
                    {
                        editingToken,
                        flowId,
                        id,
                        elementType,
                        x,
                        y,
                    },
                    null,
                    null,
                    null,
                    { id: elementType },
                );
                setContextMenuData(null);
            }),
            editMetadataAction,
            copyAction,
            deleteAction(() => {
                openConfig(
                    'Delete Map Element',
                    {
                        editingToken,
                        flowId,
                        id,
                        elementType,
                    },
                );
                setContextMenuData(null);
            }),
        ];
        break;
    }
    case 'group': {
        const element = getByID(id, groupElements);
        const { elementType } = element;
        items = [
            editAction(() => {
                openConfig(
                    getSystemFlowName(elementType),
                    {
                        editingToken,
                        flowId,
                        id,
                        elementType,
                        x,
                        y,
                    },
                    null,
                    null,
                    null,
                    { id: elementType },
                );
                setContextMenuData(null);
            }),
            editMetadataAction,
            copyAction,
            deleteAction(() => {
                openConfig(
                    'Delete Group Element',
                    {
                        editingToken,
                        flowId,
                        id,
                        elementType,
                    },
                );
                setContextMenuData(null);
            }),
        ];
        break;
    }
    default:
        items = [
            pasteAction,
        ];
        break;
    }
    
    const eventXYOffset = document.getElementsByClassName('flow-editor')[0].getBoundingClientRect();

    return (
        <div style={{ left: x - eventXYOffset.x, top: y - eventXYOffset.y }} className="graph-context-menu">
            <div className="graph-context-spacer" />
            {items}
        </div>
    );
};

export default connect(
    ({
        mapElements,
        groupElements,
        graphEditor: { contextMenu },
    }) => ({
        mapElements,
        groupElements,
        contextMenu,
    }),
    {
        setContextMenuData: setContextMenuDataAction,
    },
)(GraphContextMenu);
